<template>
  <div class="text-sm w-full">
    <span class="block mb-1 text-gray-900 tracking-wide text-sm font-semibold" v-if="label">
      {{ label }}
      <span v-if="required" class="text-coral-500">*</span>
    </span>

    <div class="relative flex flex-row">
      <textarea
        v-bind="$attrs"
        :disabled="disabled"
        :value="value"
        @focus="onFocusHandler"
        @blur="onBlurHandler"
        class="form-control"
        :class="[label ? 'mt-1' : '', lock ? 'rounded-none' : '']"
        v-on="inputListeners"
      >
      </textarea>

      <div v-if="lock" class="w-4">
        <button
          class="bg-gray-100 py-2 px-2 text-lagon-500 focus:outline-none border-gray-300 border-t border-r border-b outline-none"
          @click="$emit('update:disabled', !disabled)"
        >
          <font-awesome-icon icon="lock" v-if="disabled"></font-awesome-icon>
          <font-awesome-icon icon="lock-open" v-else></font-awesome-icon>
        </button>
      </div>
    </div>
    <span class="text-gray-500 text-xs pt-1" v-if="description">{{ description }}</span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },

    value: {
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    lock: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      initialValue: this.value
    };
  },
  computed: {
    inputListeners() {
      var vm = this;
      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit('input', event.target.value);
        }
      });
    }
  },
  methods: {
    onFocusHandler(e) {
      this.initialValue = this.value;
      if (this.value === 0 || this.value === '0') {
        this.$emit('input', null);
      }
    },
    onBlurHandler(e) {
      if ((this.initialValue === 0 || this.initialValue === '0') && !this.value) {
        this.$emit('input', 0);
      }
    }
  }
};
</script>

<style scoped></style>
